<template>
  <v-form
  class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Get KeyStore Information</h3>
    <v-layout>
      <v-flex md4>
        <v-select
            background-color="rgba(255,255,255)"
            v-model="keystoreId"
            :items="keyStoreIds"
            @change="updateRequest"
            label="Keystore Id"
            item-text="id"
            item-value="id"
            required
            outlined
            dense
        ></v-select>
        <v-divider></v-divider>
        <v-textarea
            background-color="#999999"  
            name="input-7-1"
            label="Parameters"
            class="mt-10"
            no-resize
            height="150px"
            v-model="requestPayload"
            outlined
        ></v-textarea>

      </v-flex>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="#007CA4"
            @click="validate"
            dark
        >Keystore Info >>
        </v-btn>
      </v-flex>
      <v-flex md6 style="background-color: white">
        <vue-json-pretty :path="'res'" :data=this.response> </vue-json-pretty>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

import { mapMutations } from 'vuex'
import alisonJS from  '@/services/alison_js.js'

  export default  {
    props:['keyStoreIds'],
    components: {
      VueJsonPretty,
    },
    data: () => ({
      response: null,
      keystoreId: null,
      requestPayload: '{}',
      valid: true,
    }),
    watch: {
      lastKeystoreId(){
        this.keystoreId = lastKeystoreId;
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(){
        this.requestPayload = JSON.stringify({id:this.keystoreId},null, "\t")
      },
      validate () {
        console.log("validate ref:", this.$refs)
        if (this.$refs.form.validate()) {
          this.getKeyStoreInfo()
        }
      },
      getKeyStoreInfo() {
        console.log('this.requestPayload:', this.requestPayload);
          alisonJS.keyStoreInfo(JSON.parse(this.requestPayload)).then((info) => {
            this.response = info;
              this.setColor('success')
              this.setSnack('KeyStore info obtained successfully')
              this.$emit('enableTab', ['Generate CSR'])
              this.$emit('enableTab', ['Generate Certificate'])
              this.$emit('enableTab', ['Install Certificate'])
              this.$emit('setKeyStoreId',this.keystoreId);
              var concatProfiles = []
              info.keyStores.forEach(ks => {
                  concatProfiles = concatProfiles.concat(ks.profiles)
                });
              this.$emit('setKeyStoreInfo',concatProfiles);
          }).catch(e=>{
            console.log('error:', e);
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
              if(e.message){ this.setSnack('ERROR ' + e.message) }
              else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.response = e
          })
      }
    },
  }
</script>
<style scoped>
  .v-expansion-panel-header{
    background-color: #007CA4;
  }
</style>